import React from "react";
import { Form, Input } from "antd";
import "./InputText.scss";
const { Password } = Input;

const InputText = ({ title, type, onChange, style, value, size, className }) => {
  if (type === "password") {
    return (
      <div className={"form-group"} style={style}>
        <Form.Item label={title}>
            <Password
              type={type}
              size={size}
              onChange={onChange}
              value={value}
              className={className}
            />
        </Form.Item>
      </div>
    );
  }
  return (
    <Form.Item label={title}>
      <Input className={className} type={type} size={size} onChange={onChange} value={value} />
    </Form.Item>
  );
};

export default InputText;
